import React from 'react'

import './style.css.scss'
export const TEST_ID = 'ring-loader'

const RingLoader = (props) => {
  return (
    <div data-testid={TEST_ID} className="ring-loader-container">
      <div className="ring-loader">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  )
}

export default RingLoader
